import { FC } from "react"
import { User } from "lucide-react"
import ImageUploader from "../../image-uploader"
import { UserDetails } from "../../../../types"

interface Props {
  info: UserDetails
}

const AvatarForm: FC<Props> = ({ info }) => {
  return (
    <ImageUploader
      buttonLabel="Change"
      imageUrl={info.picture}
      onChangeImageUrl={url => true}
      placeholder={<User size={96} color="#e5e5e5" />}
    />
  )
}

export default AvatarForm
